import { render, staticRenderFns } from "./DialogAnteprimaDocumento.vue?vue&type=template&id=2347c046&scoped=true"
import script from "./DialogAnteprimaDocumento.vue?vue&type=script&lang=js"
export * from "./DialogAnteprimaDocumento.vue?vue&type=script&lang=js"
import style0 from "./DialogAnteprimaDocumento.vue?vue&type=style&index=0&id=2347c046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2347c046",
  null
  
)

export default component.exports